module.exports = __webpack_public_path__ + "img/cloudforest.257a82d.jpg";